import axios from 'axios';

const host = 'http://ebook.otepc.go.th:8080';
let instance = axios.create({
    baseURL: host
});
instance.defaults.timeout = 60000;
instance.defaults.withCredentials = true;
export default instance;